export const BANNER_ACTION_SHOW_TABS = ['general'] as const;

export type BannerActionShowTab = (typeof BANNER_ACTION_SHOW_TABS)[number];

export const BANNER_ACTION_DEFAULT_TAB: BannerActionShowTab = 'general';
